module.exports = __webpack_public_path__ + "static/media/outreach-group-restless.6f7c0955.jpg";